import { render, staticRenderFns } from "./Taxcodedictionary.vue?vue&type=template&id=4f24728d&scoped=true&"
import script from "./Taxcodedictionary.vue?vue&type=script&lang=js&"
export * from "./Taxcodedictionary.vue?vue&type=script&lang=js&"
import style0 from "./Taxcodedictionary.vue?vue&type=style&index=0&id=4f24728d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f24728d",
  null
  
)

export default component.exports